import { businessErrorFactory, BusinessError } from '../../../business-error';

import { CANCEL_REPORT_BUSINESS_ERRORS } from './interfaces';

const CANCEL_REPORT_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and report could not be canceled. Please try again. If the problem still persists, contact with support.';

const CANCEL_REPORT_REPORT_NOT_FOUND =
  // eslint-disable-next-line max-len
  'Sorry but this report could not be found and canceled. It is possible that the report has already been canceled. Please refresh the page. If the problem still persists, contact with support.';

export const getCancelReportBusinessError = (businessError: CANCEL_REPORT_BUSINESS_ERRORS): BusinessError => {
  switch (businessError) {
    case CANCEL_REPORT_BUSINESS_ERRORS.REPORT_NOT_FOUND: {
      return businessErrorFactory({ message: CANCEL_REPORT_REPORT_NOT_FOUND, severity: 'warning' });
    }
    default: {
      return businessErrorFactory({
        message: CANCEL_REPORT_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};
